import clsx from 'clsx';

import styles from './styles.module.scss';
import { DocumentRequestStatusEnum } from '../../../common/request/enums/document-request-status.enum';
import { DocumentRequestStatusLabel } from '../../../common/request/ui/document-request-status';

type InputProps = {
  status: string | undefined;
};

export const DocumentStatusMapper = ({ status }: InputProps) => {
  let dotClass = styles.default;
  let title = status?.toLowerCase();
  switch (status) {
    case DocumentRequestStatusEnum.APPROVED:
      dotClass = styles.approved;
      title = DocumentRequestStatusLabel[status];
      break;
    case DocumentRequestStatusEnum.REQUESTED:
      dotClass = styles.default;
      title = DocumentRequestStatusLabel[status];
      break;
    case DocumentRequestStatusEnum.READY_FOR_REVIEW:
      dotClass = styles.uploaded;
      title = DocumentRequestStatusLabel[status];
      break;
    case DocumentRequestStatusEnum.PARTIALLY_UPLOADED:
      dotClass = styles.attention;
      title = DocumentRequestStatusLabel[status];
      break;
    case DocumentRequestStatusEnum.ATTENTION:
      dotClass = styles.attention;
      title = DocumentRequestStatusLabel[status];
      break;
    case DocumentRequestStatusEnum.UPLOADED:
      dotClass = styles.uploaded;
      title = DocumentRequestStatusLabel[status];
      break;
    case DocumentRequestStatusEnum.NEEDS_REVIEW:
      dotClass = styles.error;
      title = DocumentRequestStatusLabel[status];
      break;
  }

  return (
    <div className={styles.root}>
      <div className={clsx(styles.dot, dotClass)}></div>
      <div>{title}</div>
    </div>
  );
};
